import coreTheme from 'gatsby-theme-core/src/layout/theme';

export default {
  ...coreTheme,
  primaryColor: '#e41515',
  grayColor: '#888',
  grayDarkColor: '#232627',
  grayLightColor: '#eceff3',
  fontFamily: "'Montserrat', sans-serif",
};
